// Layout condiviso per i marcatori della sezione "Come controlliamo i prodotti".
// Usato sia dall'editor admin (MediaSections) sia dal frontend (HowWeCheck)
// così le posizioni combaciano perfettamente (WYSIWYG).

export const VW = 320;
export const VH = 256;

// Ingrandimento del device dentro il box, identico su admin e frontend.
export const DEVICE_SCALE = 1.18;

// Padding verticale (in %) per la distribuzione dei numeri lungo i bordi.
const PAD_PCT = (34 / VH) * 100; // ~13.3%
const LEFT_BX = (22 / VW) * 100; // ~6.9%
const RIGHT_BX = ((VW - 22) / VW) * 100; // ~93.1%

/**
 * Calcola le posizioni di default dei numeri (badge) in percentuale.
 * @param {Array<{x:number,y:number}>} points punti del device in % (0-100)
 * @returns {Object<number,{bx:number,by:number}>}
 */
export function computeBadgeLayout(points) {
  const pts = points.map((p, i) => ({ i, x: Number(p.x) || 0, y: Number(p.y) || 0 }));
  const byX = [...pts].sort((a, b) => a.x - b.x);
  const half = Math.ceil(byX.length / 2);
  const leftIds = new Set(byX.slice(0, half).map((o) => o.i));
  const left = pts.filter((o) => leftIds.has(o.i)).sort((a, b) => a.y - b.y);
  const right = pts.filter((o) => !leftIds.has(o.i)).sort((a, b) => a.y - b.y);
  const place = (list, bx) =>
    list.map((o, k) => ({
      i: o.i,
      bx,
      by: list.length > 1 ? PAD_PCT + (k * (100 - 2 * PAD_PCT)) / (list.length - 1) : 50,
    }));
  const all = [...place(left, LEFT_BX), ...place(right, RIGHT_BX)];
  const map = {};
  all.forEach((m) => (map[m.i] = { bx: m.bx, by: m.by }));
  return map;
}
